import { useNavigate } from 'react-router-dom';
import { EditPage, EditPageTextField, EditPagePanel } from './../../../common/EditPage';
import { update, getOne } from './../../../common/v4/BackendProvider';
import { ToastContainer, toast } from 'react-toastify';
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

const CurrencyEdit = () => {
    const navigate = useNavigate();
    const [data, setData] = useState({});
    const [defaultCurrency, setDefaultCurrency] = useState({});
    const { currency_id } = useParams();
    useEffect(() => {
        getOne('/admin/settings/currencies/', currency_id).then(response => {
            setData(response.data.data);
        });
        getOne('/admin/settings/currencies/', 1).then(response => {
            setDefaultCurrency(response.data.data);
        });
    }, [currency_id]);

    const handleSave = () => {
        update('/admin/settings/currencies/', currency_id, {data: data}).then(response => {
            toast.success("Currency updated successfully", {});
            navigate('/settings/currencies');
        }).catch(error => {
            toast.error("Error updating currency: " + error.message, {});
        });
    }

    const handleCancel = () => {
        navigate('/settings/currencies');
    }

    const onChange = (id, value) => {
        setData({ ...data, [id]: value });
    }

    return (
        <div>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                closeOnClick={true}
                pauseOnHover={true}
                draggable={true}
                progress="undefined"
            />
            <EditPage handleSave={ handleSave } handleCancel={ handleCancel } title={`Update Currency (${data.ATRCURNAME})`} >
                <EditPagePanel>
                    <EditPageTextField label="ISO Code" id="ATRCURNAME" disabled={ true } onChange={ onChange } value={ data.ATRCURNAME } />
                    <EditPageTextField label="Name" id="ATRCURDSCR" onChange={ onChange } value={ data.ATRCURDSCR } />
                    <EditPageTextField label={`Exchange Rate (against ${defaultCurrency.ATRCURNAME})`} id="ATRCURRATE" onChange={ onChange } value={ data.ATRCURRATE } />
                </EditPagePanel>
            </EditPage>
        </div>
    )
}

export default CurrencyEdit;